/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { GET_PROPOSAL_COLUMN, OPTIONS, getProposalColorByStatus } from './utils';
import { ParcelClient, PlaceDetails } from '../../services/api';
import createParcelsListFromRowData from '../../models/modelFactory/parcel';
import { AppContextType, useApp } from '../../context/AppContext';
import useQuery from '../../hooks/useQuery';

const Proposal = (): JSX.Element => {
  const { t } = useTranslation();
  const TITLE = t("proposal");
  const [data, setData] = useState<any>([]);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRaws, setTotalRaws] = useState<number>(0);

  const { getPaginatedParcels } = ParcelClient();
  const { getPlaceDetails } = PlaceDetails();
  const { baggages } = useApp() as AppContextType;

  const history = useHistory();
  const query = useQuery();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get('page') as string) || 1;
  const pageSize = parseInt(queryParams.get('pageSize') as string) || 10;

  useEffect(() => {
    (async () => {
      const { items, total, totalPages } = await getPaginatedParcels(page, pageSize, null, { isDraft: true });
      const parsedData = items ? createParcelsListFromRowData(items, baggages, t) : [];
      const fromData = await Promise.all(parsedData.map(parcel => parcel.fromPlaceId && getPlaceDetails(parcel.fromPlaceId)));
      const toData = await Promise.all(parsedData.map(parcel => parcel.toPlaceId && getPlaceDetails(parcel.toPlaceId)));
      const localizedData = parsedData.map(parcel => {
        const from = fromData.find(item => item?.placeId === parcel.fromPlaceId);
        const to = toData.find(item => item?.placeId === parcel.toPlaceId);
        return {
          ...parcel,
          addressFrom: from?.name ?? parcel.addressFrom,
          addressTo: to?.name ?? parcel.addressTo
        }
      });
      setTotalRaws(total);
      setTotalPages(totalPages);
      setData(localizedData);
    })();
  }, [baggages, t, page, pageSize]);

  const onChangePage = (currentPage: number) => {
    history.push(`?page=${currentPage + 1}&pageSize=${pageSize}`);
  };

  const queryObject: any = query.getObject();

  const column = useMemo(() => GET_PROPOSAL_COLUMN(queryObject, t), []);

  return (
    <React.Fragment>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
        <div style={{ width: '90%' }}>
          <MUIDataTable
            title={TITLE}
            data={data}
            columns={column}
            options={{
              ...OPTIONS(t),
              setRowProps: (row) => {
                return {
                  style: {
                    background: getProposalColorByStatus(row[12])
                  }
                };
              },
              serverSide: true,
              onChangeRowsPerPage: (numberOfRows) => {
                history.push(`?page=1&pageSize=${numberOfRows}`);
              },
              filter: false,
              download: false,
              rowsPerPage: pageSize,
              page: page - 1,
              onChangePage,
              pagination: totalPages > 1,
              rowsPerPageOptions: [5, 10, 25, 50, 100],
              count: totalRaws
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Proposal;
